/**
 * KINDW-1598: PDP inventory ids — warehouse resolved from PDP delivery estimate only.
 * Never falls back to checkout cookies (see useShopperInventoryIds + isPdpScope).
 */

import {useMemo} from 'react';

import {usePdpWarehouseInventoryContext} from '../context/pdp-warehouse-inventory-context';

/**
 * @returns {{
 *   shopperInventoryIds: string|undefined,
 *   isInventoryIdsResolving: boolean,
 * }}
 */
export function usePdpShopperInventoryIds() {
  const {inventoryIds, isActive, isResolving} = usePdpWarehouseInventoryContext();

  return useMemo(
    () => ({
      shopperInventoryIds: isActive ? inventoryIds : undefined,
      isInventoryIdsResolving: Boolean(isActive && isResolving),
    }),
    [inventoryIds, isActive, isResolving]
  );
}

export default usePdpShopperInventoryIds;
